import Icon from './Icon';
import Button from './Button';
import type { IconName } from '@/theme/icons';

/** Ported from src/components/ui/EmptyState.tsx. */
export default function EmptyState({
  icon,
  title,
  body,
  ctaTitle,
  onCta,
}: {
  icon: IconName;
  title: string;
  body: string;
  ctaTitle?: string;
  onCta?: () => void;
}) {
  return (
    <div className="empty-state">
      <span className="empty-state-icon">
        <Icon name={icon} size={28} color="var(--color-primary)" />
      </span>
      <h2 className="type-title">{title}</h2>
      <p className="type-body empty-state-body">{body}</p>
      {ctaTitle && onCta && <Button title={ctaTitle} onPress={onCta} />}
    </div>
  );
}
